<template>

    <div class="canvas::editor-admin-ModeAndViewportToolbar shrink-0">

        <div class="relative z-0 inline-flex shadow-sm rounded-md ml-10">

            <button
                class="relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                type="button"
                :class="{ 'bg-indigo-50': activeMode === 'overview' }"
                @click="onOverviewClick"
                title="Bekijk en bewerk de content vanaf een afstand.">
                <i class="far fa-search-minus mr-2"></i>
                <span>Overzicht</span>
            </button>

            <button
                class="-ml-px relative inline-flex items-center px-4 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                :class="{ 'bg-indigo-50': activeMode === 'content' }"
                type="button"
                @click="$emit('update:activeMode', 'content')"
                title="Bewerk de individuele blokken op detailniveau.">
                <i class="far fa-pencil mr-2"></i>
                <span>Content</span>
            </button>

        </div>

        <div class="relative z-0 inline-flex shadow-sm rounded-md ml-10">

            <button v-for="(viewport, id, key) in viewports"
                    class="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                    :class="{ 'bg-indigo-50': activeViewport === id, 'rounded-r-md': key === Object.keys(viewports).length - 1, 'rounded-l-md': key === 0 }"
                    type="button"
                    :title="viewport.title"
                    @click="setActiveViewport(id)">
                <i class="far fa-fw" :class="viewport.icon"></i>
            </button>

        </div>

    </div>

</template>

<script>

export default {

    props: {
        activeMode: String,
        activeViewport: String,
    },

    data() {
        return {
            viewports: {
                xs: {icon: 'fa-mobile', title: 'Mobiel'},
                sm: {icon: 'fa-tablet', title: 'Tablet rechtopstaand'},
                md: {icon: 'fa-tablet fa-rotate-90', title: 'Tablet gedraaid'},
                lg: {icon: 'fa-laptop', title: 'Laptop'},
                xl: {icon: 'fa-desktop', title: 'Desktop'},
            },
        };
    },

    methods:
        {
            setActiveViewport(id) {
                // Abort due to no change?
                if (this.activeViewport === id)
                    return;

                // Set
                this.$emit('update:activeViewport', id);

                // Go to edit mode since overview does not support this mode?
                if (this.activeMode === 'overview')
                    this.$emit('update:activeMode', 'content');
            },

            onOverviewClick() {
                // Update active mode.
                this.$emit('update:activeMode', 'overview')

                this.setActiveViewport(_.last(Object.keys(this.viewports)));
            },
        },

    watch: {

        'activeMode'(newVal, oldVal) {
            // Set to XL for a good preview?
            if (newVal === 'overview')
                this.setActiveViewport(_.last(Object.keys(this.viewports)));
        },

    },

}

</script>

<style lang="scss" scoped>

.canvas\:\:editor-admin-ModeAndViewportToolbar {

}

</style>
